"use client";

import React from "react";
import { ShieldCheck, Info } from "lucide-react";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const certifications = [{
  id: "pt",
  name: "物理治療師 (PT)",
  description: "制定個人化居家運動計劃，專注於改善肢體功能、步態訓練及預防跌倒。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/gmp_certification_monochrome_logo.png"
}, {
  id: "st",
  name: "言語治療師 (ST)",
  description: "處理吞嚥困難及溝通障礙，透過專業訓練提升進食安全與社交表達能力。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/haccp_certification_monochrome_logo.png"
}, {
  id: "dietitian",
  name: "註冊營養師",
  description: "根據病歷制定專屬營養餐單，優化身體康復進度，並提供慢性疾病飲食諮詢。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/iso22000_certification_monochrome_logo.png"
}, {
  id: "hw",
  name: "保健員 (HW)",
  description: "提供日常起居照顧，密切監察生命徵象，是長者與社區資源聯繫的重要橋樑。",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/fda_facility_monochrome_logo.png"
}];
export default function ProfessionalCertifications() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: scrollRef,
    isVisible: isScrollVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return;
}